import React from "react";
import { CheckCircle2, HelpCircle } from "lucide-react";
import { GuestChip } from "@/components/GuestChip";
import { t, tf } from "@/i18n";

export const ToDecideTray = ({
  plan,
  guestMap,
  onSelectGuest,
  onRequestMove,
  onDropToTray,
  draggingGuest,
  onDragStart,
  onDragEnd,
}) => {
  const items = plan?.unseated || [];
  const total = items.reduce((sum, item) => sum + item.guest_ids.length, 0);

  return (
    <section
      data-testid="to-decide-tray"
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => {
        event.preventDefault();
        const guestId = event.dataTransfer.getData("text/plain");
        if (guestId) onDropToTray?.(guestId);
      }}
      className="surface rounded-xl p-4"
      aria-label={t("tray.aria")}
    >
      <header className="mb-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <HelpCircle className="h-4 w-4" style={{ color: "var(--warning)" }} />
          <h2 className="font-display text-lg font-semibold leading-none">{t("tray.title")}</h2>
          <span
            className="font-num rounded-full px-2 py-0.5 text-[11px] font-semibold"
            style={{
              backgroundColor: total ? "#fdf6ea" : "#f0f4f1",
              color: total ? "#9a7a3f" : "var(--success)",
            }}
            data-testid="to-decide-count"
          >
            {total}
          </span>
        </div>
        <p className="text-[11px] text-[color:var(--muted-ink)]">{t("tray.hint")}</p>
      </header>

      {!items.length ? (
        <div className="flex items-center gap-2 rounded-lg surface-2 px-3 py-3">
          <CheckCircle2 className="h-4 w-4" style={{ color: "var(--success)" }} />
          <p className="text-[12.5px] text-[color:var(--ink-soft)]">{t("tray.empty")}</p>
        </div>
      ) : (
        <ul className="space-y-2">
          {items.map((item) => (
            <li
              key={item.guest_ids.join("-")}
              data-testid={`to-decide-guest-row-${item.guest_ids[0]}`}
              className="flex flex-wrap items-center justify-between gap-2 rounded-lg surface-2 px-2.5 py-2"
            >
              <div className="flex flex-wrap items-center gap-1.5">
                {item.guest_ids.map((guestId) =>
                  guestMap[guestId] ? (
                    <GuestChip
                      key={guestId}
                      guest={guestMap[guestId]}
                      onSelect={onSelectGuest}
                      onRequestMove={onRequestMove}
                      onDragStart={onDragStart}
                      onDragEnd={onDragEnd}
                      dragging={draggingGuest?.id === guestId}
                    />
                  ) : null
                )}
              </div>
              <p className="text-[11.5px] text-[color:var(--ink-soft)]">
                {item.reason === "avoid_conflict"
                  ? tf("tray.avoidReason", { names: (item.blocked_by || []).join(", ") || t("tray.someone") })
                  : item.reason === "organiser_decision"
                    ? t("tray.organiser")
                    : t("tray.noSeat")}
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default ToDecideTray;
